import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import DatePicker from 'components/ui/DatePicker';
import { Column, Row } from 'components/shared/Layout';
import { Spinner } from 'admin-components/components';
import Select from 'components/ui/Select';
import { ActionButton } from 'components/ui/Button';
import { ErrorField, Field, MandatoryFieldLabel, StyledForm, StyledSubmitField } from './SearchBooking.styles';
import { useSpecialAssistanceForm } from './SearchBySpecialAssistance.utils';

const SearchBySpecialAssistance = ({ onSubmitSearch }) => {
  const { form, loading, onSubmit, stations } = useSpecialAssistanceForm(onSubmitSearch);

  if (loading) {
    return (
      <Row height="100vh">
        <Column alignItems="center" justifyContent="center">
          <Spinner />
        </Column>
      </Row>
    );
  }

  return (
    <StyledForm onSubmit={onSubmit}>
      <Field>
        <MandatoryFieldLabel htmlFor="station-input">
          <FormattedMessage id="searchBooking.station" />
        </MandatoryFieldLabel>
        <Select {...form.register('station', { required: true })} id="station-input">
          {stations.map(({ name, uic }) => (
            <option key={name} value={uic}>
              {name}
            </option>
          ))}
        </Select>
        {form.formState.errors.station && (
          <ErrorField>
            <FormattedMessage id="searchBooking.minorsStationValidationMessage" />
          </ErrorField>
        )}
      </Field>
      <Field>
        <MandatoryFieldLabel htmlFor="date-input">
          <FormattedMessage id="searchBooking.departureDate" />
        </MandatoryFieldLabel>
        <DatePicker
          name="date"
          id="date"
          value={form.getValues().date}
          clearTravelDate={() =>
            form.setValue('date', '', {
              shouldValidate: true
            })
          }
          setTravelDate={(_, date) =>
            form.setValue('date', date, {
              shouldValidate: true
            })
          }
          setErrorMessage={(error) => form.setError('date', { type: 'validate', message: error })}
          errorMessage={form.formState.errors.date?.type}
        />
      </Field>
      <StyledSubmitField>
        <ActionButton type="submit" disabled={!form.formState.isValid}>
          <FormattedMessage id="searchBooking.search" />
        </ActionButton>
      </StyledSubmitField>
    </StyledForm>
  );
};

SearchBySpecialAssistance.propTypes = {
  onSubmitSearch: PropTypes.func.isRequired
};

export default SearchBySpecialAssistance;
